/**
 * How a user reaches us (SVC-277).
 *
 * Here rather than inline at each use because these appear on the support
 * screen, the download page and the marketing site — and a support address
 * that is right in two places and stale in a third is worse than one that is
 * merely hard to find.
 */

export const SUPPORT_EMAIL = "support@eazyserv.com";

/** E.164 for `tel:` links; `SUPPORT_PHONE_DISPLAY` is what a human reads. */
export const SUPPORT_PHONE = "+918698586975";
export const SUPPORT_PHONE_DISPLAY = "+91 86985 86975";
